import client from "../Client/HttpClient";
import { ICourseGroupCapacityRulesModel } from "@/interfaces/modules";

const ApiPath = "CourseGroupCapacityRules";

export default {
  /** GET api/CourseGroupCapacityRules */
  GetAll: (): Promise<ICourseGroupCapacityRulesModel[]> =>
    client.get(`${ApiPath}`),

  /** GET api/CourseGroupCapacityRules/{id} */
  GetById: (id: number): Promise<ICourseGroupCapacityRulesModel> =>
    client.get(`${ApiPath}/${id}`),

  /** GET api/CourseGroupCapacityRules/byCourseGroup/{courseGroupId} */
  GetByCourseGroupId: (courseGroupId: number): Promise<ICourseGroupCapacityRulesModel> =>
    client.get(`${ApiPath}/byCourseGroup/${courseGroupId}`),

  /** GET api/CourseGroupCapacityRules/byAcademicYear/{academicYearId} */
  GetByAcademicYearId: (academicYearId: number): Promise<ICourseGroupCapacityRulesModel[]> =>
    client.get(`${ApiPath}/byAcademicYear/${academicYearId}`),

  /** POST api/CourseGroupCapacityRules */
  Post: (data: ICourseGroupCapacityRulesModel): Promise<ICourseGroupCapacityRulesModel> =>
    client.post(`${ApiPath}`, data),
};
